import RadioGroup from "components/DesignSystem/RadioGroup/RadioGroup";
import { FIELD_TYPE, REVIEW_ACTION } from "v2/constants/extractionReview";
import type {
  ReviewActionFn,
  ReviewField,
  ReviewFieldAction,
} from "v2/types/extractionReview.types";
import { renderTypedValue } from "v2/utils/renderTypedValue";
import { ConfirmRejectButtons } from "./ConfirmRejectButtons";
import { FieldLabel } from "./FieldLabel";
import { KeyValueList } from "./KeyValueList";

type ConflictRowProps = {
  field: ReviewField;
  onAction: ReviewActionFn;
  pendingAction?: ReviewFieldAction | null;
};

export const ConflictRow = ({
  field,
  onAction,
  pendingAction = null,
}: ConflictRowProps) => {
  const { field_id: id, label, type } = field;
  const isObject = type === FIELD_TYPE.OBJECT;
  return (
    <div className="t-flex t-items-center t-justify-between t-gap-4 sm:t-flex-col sm:t-items-start sm:t-gap-3">
      <div className="t-flex t-min-w-0 t-flex-1 t-flex-col t-gap-2 sm:t-w-full sm:t-break-all">
        <FieldLabel>{label}</FieldLabel>
        <RadioGroup.Root
          value={field.chosen_candidate_uuid ?? ""}
          onValueChange={(value) => onAction(id, REVIEW_ACTION.CHOOSE, value)}
          className="t-flex t-flex-col t-gap-2"
        >
          {field.candidates.map((c) => (
            <RadioGroup.Item
              key={c.candidate_uuid}
              value={c.candidate_uuid}
              description={
                c.source_doc_name ? `from ${c.source_doc_name}` : undefined
              }
            >
              {isObject ? (
                <KeyValueList value={c.value} labels={field.value_labels} />
              ) : (
                <span className="t-text-text-100">
                  {renderTypedValue(c.value, type)}
                </span>
              )}
            </RadioGroup.Item>
          ))}
        </RadioGroup.Root>
      </div>
      <ConfirmRejectButtons
        id={id}
        onAction={onAction}
        rejectAsChoose
        confirmDisabled={!field.chosen_candidate_uuid}
        confirmCandidateUuid={field.chosen_candidate_uuid ?? undefined}
        pendingAction={pendingAction}
      />
    </div>
  );
};
